import React from "react"
import classnames from "classnames"
import componentParser from "AtomicUtils/componentParser"
import styles from "./IdWrapper.less"

class IdWrapper extends React.PureComponent {
  render() {
    const { slug, components, children, standalone = false } = this.props

    return (
      <section
        data-test="id-wrapper"
        data-name={slug}
        className={classnames({
          [styles.IdWrapper]: true
        })}>
        <a
          data-id={slug}
          className={classnames({
            [styles.IdWrapperSlug]: true,
            [styles.IdWrapperSlugStandalone]: standalone,
          })} />
        {componentParser(components, this.props) || children}
      </section>
    )
  }
}

export default IdWrapper



// WEBPACK FOOTER //
// ./src/AtomicComponents/IdWrapper/IdWrapper.jsx